$(document).ready(() => {
  $('.btn-close').click((e) => {
    $(e.currentTarget)
      .parent()
      .toggleClass('hidden')
    ;
  });
  $('.btn--play').click(() => {
    $('.video__object__player__cover').hide();
  });

  $('.js-video__download').click(() => {
    $('.video__object__player__overlay--download').toggleClass('hidden');
  });

  $('.js-video__share').click(() => {
    $('.video__object__player__overlay--share').toggleClass('hidden');
  });
});
